import styled from 'styled-components'

export const StyledNoPhysicians = styled.div({
  flexDirection: 'column',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50vh'
})
